import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext({ showAccountSettings: false, setShowAccountSettings: () => {} });
export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [showAccountSettings, setShowAccountSettings] = useState(false);
  return (
    <UIContext.Provider value={{ showAccountSettings, setShowAccountSettings }}>
      {children}
    </UIContext.Provider>
  );
};
